"use client";
import React, { useState } from "react";
import MerchantFaqsAccordion from "./MerchantFaqsAccordion";
import { ArrowDown, ArrowUp } from "lucide-react";

const FaqListClient = ({ faqs }: { faqs: any[] }) => {
  const [showAll, setShowAll] = useState(false);
  const visible = showAll ? faqs : faqs.slice(0, 8);

  const mid   = Math.ceil(visible.length / 2);
  const left  = visible.slice(0, mid);
  const right = visible.slice(mid);

  return (
    <div>
      {/* two-column list */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-14 gap-y-0">

        <div className="divide-y divide-slate-100">
          {left.map((faq: any, idx: number) => (
            <MerchantFaqsAccordion key={`l-${idx}`} faq={faq} index={idx} />
          ))}
        </div>

        <div className="divide-y divide-slate-100 mt-0 lg:mt-0">
          {right.map((faq: any, idx: number) => (
            <MerchantFaqsAccordion key={`r-${idx}`} faq={faq} index={idx + mid} />
          ))}
        </div>

      </div>

      {/* show more / less */}
      {faqs.length > 8 && (
        <div className="flex justify-center mt-4 pt-8">
          <button
            onClick={() => setShowAll(!showAll)}
            className="group inline-flex items-center gap-2.5 h-11 px-8
              border border-slate-200 hover:border-indigo-950 bg-white hover:bg-indigo-950
              text-slate-500 hover:text-white
              text-[11px] font-black uppercase tracking-[0.2em] rounded-xl
              transition-all duration-300 active:scale-95 shadow-sm"
          >
            {showAll ? (
              <>Show Less <ArrowUp size={13} strokeWidth={2.5} /></>
            ) : (
              <>Show More <ArrowDown size={13} strokeWidth={2.5} /></>
            )}
          </button>
        </div>
      )}
    </div>
  );
};

export default FaqListClient;
